import DefaultList from "@/components/DefaultList";
import { Module, PATH_DICTS_PROJECT_TYPES } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import ProjectTypeCreator from "@/modules/projectTypes/components/ProjectTypeCreator";
import ProjectTypeEditor from "@/modules/projectTypes/components/ProjectTypeEditor";
import { createProjectType, readProjectType } from "@/schemas/projectType";
import { ProjectTypesService } from "@/services/projectType";
import { CreateProjectType, ReadProjectType } from "@/types/projectType";
import { FolderDot } from "lucide-react";
import { Row } from "@tanstack/react-table";
import i18n from "@/i18n";
import {
  PROJECT_DEPENDENCY_ROLE,
  PROJECT_DEPENDS_ON,
} from "@/schemas/commonFields/projectDependsOn";
import { EnumFilter } from "@/components/data-table/components/EnumFilter";

const id = Module.ProjectTypes;
const path = PATH_DICTS_PROJECT_TYPES;
const ns = "projectTypes";

const config: DictionaryConfig<ReadProjectType, CreateProjectType> = {
  id,
  ns,
  service: ProjectTypesService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: createProjectType,
  defaultValues: {
    name: "",
    project_depends_on: PROJECT_DEPENDENCY_ROLE,
    available_for_structure: false,
  },
  Icon: FolderDot,
  List: () => (
    <DefaultList<ReadProjectType>
      schema={readProjectType}
      name={ns}
      fetchList={ProjectTypesService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.ProjectTypes },
      }}
      columnOverrides={{
        project_depends_on: {
          id: "project_depends_on",
          cell: ({ row }: { row: Row<ReadProjectType> }) =>
            i18n.t(
              `projectTypes.enum.project_depends_on.${row.original.project_depends_on}`,
            ),
          meta: {
            filter: {
              component: EnumFilter,
              props: {
                options: PROJECT_DEPENDS_ON,
                translationKey: "projectTypes.enum.project_depends_on",
              },
            },
          },
        },
      }}
    />
  ),
  Creator: ProjectTypeCreator,
  Editor: ProjectTypeEditor,
};

export default config;
